const n = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "button",
  "submit",
  "reset",
  "range",
  "color",
  "file",
  "image",
  "hidden"
]), i = (e) => e instanceof HTMLElement ? e.isContentEditable ? !0 : "disabled" in e && e.disabled ? !1 : e instanceof HTMLTextAreaElement ? !e.readOnly : e instanceof HTMLInputElement ? !e.readOnly && !n.has(e.type) : !1 : !1;
export {
  i as isEditableInput
};
